import React from 'react';
import { Container, Row, Col, Button} from 'react-bootstrap';

import './news_styles/newsmiddle.css';

export default function NewsMiddle() {
  return (
    <>
      <Container className='news_middle mt-3 mb-3'>
        <Row>
          <Col>
           <div className="news_middle_content d-flex flex-column justify-content-center align-items-center">
            <h3>NEWS</h3>
            <p>Learn everything about blockchain, Web3 and cryptocurrency</p>
           </div>
           <div className="news_middle_btns d-flex justify-content-center gap-2">
             <Button>Loream Ipsum</Button>
             <Button>Loream Ipsum</Button>
           </div>
          </Col>
        </Row>
      </Container>
    </>
  )
}
